import { Link } from 'react-router';

export const BottomMenuSubMenuItem = ({ closeMenu, label, link, onClick }) => {
    const linkClassName = "group-hover:text-is2-blue hover:!text-is2-blue text-is2-gray-700 text-is2_sm flex w-full !my-0 !py-0";
    const isAbsoluteUrl = !onClick && link.startsWith('https://');

    return (
        <div className="group cursor-pointer py-1.5" onClick={closeMenu}>
            {isAbsoluteUrl ? (
                <a className={linkClassName} href={link} rel="noopener noreferrer" target="_blank">{label}</a>
            ) : onClick ? (
                <a href="#c" className={linkClassName} onClick={onClick}>{label}</a>
            ) : (
                <Link className={linkClassName} to={link}>{label}</Link>
            )}
        </div>
    );
};
